import { Box, Tab, Tabs, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import OverviewPage from './OverviewPage';
import ActivitiesPage from './ActivitiesPage';
import CustomersPage from './CustomersPage';
import SalesPage from './SalesPage';
import OffersPage from './OffersPage';
import ProductsPage from './ProductsPage';
import TasksPage from './TasksPage';
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}
export default function ReportsPage() {
  const [value, setValue] = React.useState(0);

  const { t } = useTranslation();
  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab label={t(`REPORTS.OVERIEW`)} {...a11yProps(0)} />
          <Tab label={t(`REPORTS.ACTIVITIES`)} {...a11yProps(1)} />
          <Tab label={t(`REPORTS.CUSTOMERS`)} {...a11yProps(2)} />
          <Tab label={t(`REPORTS.SALES`)} {...a11yProps(3)} />
          <Tab label={t(`REPORTS.OFFERS`)} {...a11yProps(4)} />
          <Tab label={t(`REPORTS.PRODUCTS`)} {...a11yProps(5)} />
          <Tab label={t(`REPORTS.TASKS`)} {...a11yProps(6)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <OverviewPage />
      </CustomTabPanel>

      <CustomTabPanel value={value} index={1}>
        <ActivitiesPage />
      </CustomTabPanel>

      <CustomTabPanel value={value} index={2}>
        <CustomersPage />
      </CustomTabPanel>

      <CustomTabPanel value={value} index={3}>
        <SalesPage />
      </CustomTabPanel>

      <CustomTabPanel value={value} index={4}>
        <OffersPage />
      </CustomTabPanel>

      <CustomTabPanel value={value} index={5}>
        <ProductsPage />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={6}>
        <TasksPage />
      </CustomTabPanel>
    </Box>
  );
}
